module.exports = __webpack_public_path__ + "img/product_4.f737fc7.webp";